export const scales = {
  y: {
    beginAtZero: true,
    position: "bottom",
    ticks: {
      precision: 0,
      beginAtZero: true,
    },
  },
  x: {
    ticks: {
      autoSkip: true,
      maxRotation: 45,
      minRotation: 45,
    },
  },
};

export const plugins = {
  legend: {
    display: false,
  },
};

const LineChartConfig = {
  scales,
  plugins,
};

export default LineChartConfig;
